import React from 'react';
import ButtonComponent from '../components/Button';
import { useNavigate } from 'react-router-dom';
import '../styles/notFound.css';

const NotFoundBlog = () => {
  const navigate = useNavigate();
  
  const handleClick = () => {
    navigate('/blogs')
  }
  
	return (
		<div className="component_wrapper not_found_container">
			<h1 className="not_found_header">404</h1>
			<p className="not_found_description">Blog doesn't exist</p>
			<ButtonComponent onClick={handleClick} name="Return to blogs" className="btn_primary btn_not_found"/>
		</div>
	);
};

export default NotFoundBlog;
